import React, {Component} from 'react';
import {connect} from 'react-redux';
import CombinationChecking from './combination-checking';
import CombinationExposure from './combination-exposure';

class CombinationOptions extends Component {
    render() {
        const {stacking} = this.props;
        const combinations = stacking.getCombinations();

        let combinationBlocks = [];
        Object.keys(combinations).map((comboKey) => {
            combinationBlocks.push(
                <div key={comboKey} className="stack-box">
                    <CombinationChecking comboKey={comboKey} />
                    <div className="percent-in">
                        <CombinationExposure comboKey={comboKey} />
                        <span className="percent">%</span>
                    </div>
                </div>,
            );
        });

        return (
            <div className="nhl-stack-combinations">
                <h3>Choose stack combinations</h3>
                <div className="stack-box-holder">{combinationBlocks}</div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {nonControlledHitterStacking} = state;
    return {
        stacking: nonControlledHitterStacking.settings,
    };
}

export default connect(mapStatesToProps)(CombinationOptions);
